export var AccountOrderByInput;
(function (AccountOrderByInput) {
    AccountOrderByInput["IdAsc"] = "id_ASC";
    AccountOrderByInput["IdDesc"] = "id_DESC";
})(AccountOrderByInput = AccountOrderByInput || (AccountOrderByInput = {}));
export var AccountTransferOrderByInput;
(function (AccountTransferOrderByInput) {
    AccountTransferOrderByInput["AccountIdAsc"] = "account_id_ASC";
    AccountTransferOrderByInput["AccountIdDesc"] = "account_id_DESC";
    AccountTransferOrderByInput["DirectionAsc"] = "direction_ASC";
    AccountTransferOrderByInput["DirectionDesc"] = "direction_DESC";
    AccountTransferOrderByInput["EventBlockHashAsc"] = "event_blockHash_ASC";
    AccountTransferOrderByInput["EventBlockHashDesc"] = "event_blockHash_DESC";
    AccountTransferOrderByInput["EventBlockNumAsc"] = "event_blockNum_ASC";
    AccountTransferOrderByInput["EventBlockNumDesc"] = "event_blockNum_DESC";
    AccountTransferOrderByInput["EventFromAsc"] = "event_from_ASC";
    AccountTransferOrderByInput["EventFromDesc"] = "event_from_DESC";
    AccountTransferOrderByInput["EventIdAsc"] = "event_id_ASC";
    AccountTransferOrderByInput["EventIdDesc"] = "event_id_DESC";
    AccountTransferOrderByInput["EventPriceAsc"] = "event_price_ASC";
    AccountTransferOrderByInput["EventPriceDesc"] = "event_price_DESC";
    AccountTransferOrderByInput["EventTimestampAsc"] = "event_timestamp_ASC";
    AccountTransferOrderByInput["EventTimestampDesc"] = "event_timestamp_DESC";
    AccountTransferOrderByInput["EventToAsc"] = "event_to_ASC";
    AccountTransferOrderByInput["EventToDesc"] = "event_to_DESC";
    AccountTransferOrderByInput["EventTypeAsc"] = "event_type_ASC";
    AccountTransferOrderByInput["EventTypeDesc"] = "event_type_DESC";
    AccountTransferOrderByInput["IdAsc"] = "id_ASC";
    AccountTransferOrderByInput["IdDesc"] = "id_DESC";
})(AccountTransferOrderByInput = AccountTransferOrderByInput || (AccountTransferOrderByInput = {}));
export var Direction;
(function (Direction) {
    Direction["From"] = "FROM";
    Direction["To"] = "TO";
})(Direction = Direction || (Direction = {}));
export var EventType;
(function (EventType) {
    EventType["AttributeClear"] = "ATTRIBUTE_CLEAR";
    EventType["AttributeSet"] = "ATTRIBUTE_SET";
    EventType["Bought"] = "BOUGHT";
    EventType["Burn"] = "BURN";
    EventType["Create"] = "CREATE";
    EventType["Destroy"] = "DESTROY";
    EventType["ForceCreate"] = "FORCE_CREATE";
    EventType["Freeze"] = "FREEZE";
    EventType["MaxSupplySet"] = "MAX_SUPPLY_SET";
    EventType["MetadataClear"] = "METADATA_CLEAR";
    EventType["MetadataSet"] = "METADATA_SET";
    EventType["Mint"] = "MINT";
    EventType["OwnerChange"] = "OWNER_CHANGE";
    EventType["PriceRemoved"] = "PRICE_REMOVED";
    EventType["PriceSet"] = "PRICE_SET";
    EventType["TeamChange"] = "TEAM_CHANGE";
    EventType["Thawe"] = "THAWE";
    EventType["Trnasfer"] = "TRNASFER";
})(EventType = EventType || (EventType = {}));
export var Status;
(function (Status) {
    Status["Active"] = "ACTIVE";
    Status["Destroyed"] = "DESTROYED";
    Status["Frozen"] = "FROZEN";
    Status["Listed"] = "LISTED";
})(Status = Status || (Status = {}));
export var UniqueClassOrderByInput;
(function (UniqueClassOrderByInput) {
    UniqueClassOrderByInput["AdminAsc"] = "admin_ASC";
    UniqueClassOrderByInput["AdminDesc"] = "admin_DESC";
    UniqueClassOrderByInput["CreatedAtAsc"] = "createdAt_ASC";
    UniqueClassOrderByInput["CreatedAtDesc"] = "createdAt_DESC";
    UniqueClassOrderByInput["CreatorAsc"] = "creator_ASC";
    UniqueClassOrderByInput["CreatorDesc"] = "creator_DESC";
    UniqueClassOrderByInput["FreezerAsc"] = "freezer_ASC";
    UniqueClassOrderByInput["FreezerDesc"] = "freezer_DESC";
    UniqueClassOrderByInput["IdAsc"] = "id_ASC";
    UniqueClassOrderByInput["IdDesc"] = "id_DESC";
    UniqueClassOrderByInput["IssuerAsc"] = "issuer_ASC";
    UniqueClassOrderByInput["IssuerDesc"] = "issuer_DESC";
    UniqueClassOrderByInput["MaxSupplyAsc"] = "maxSupply_ASC";
    UniqueClassOrderByInput["MaxSupplyDesc"] = "maxSupply_DESC";
    UniqueClassOrderByInput["MetadataAsc"] = "metadata_ASC";
    UniqueClassOrderByInput["MetadataDesc"] = "metadata_DESC";
    UniqueClassOrderByInput["OwnerAsc"] = "owner_ASC";
    UniqueClassOrderByInput["OwnerDesc"] = "owner_DESC";
    UniqueClassOrderByInput["StatusAsc"] = "status_ASC";
    UniqueClassOrderByInput["StatusDesc"] = "status_DESC";
})(UniqueClassOrderByInput = UniqueClassOrderByInput || (UniqueClassOrderByInput = {}));
export var UniqueEventOrderByInput;
(function (UniqueEventOrderByInput) {
    UniqueEventOrderByInput["BlockHashAsc"] = "blockHash_ASC";
    UniqueEventOrderByInput["BlockHashDesc"] = "blockHash_DESC";
    UniqueEventOrderByInput["BlockNumAsc"] = "blockNum_ASC";
    UniqueEventOrderByInput["BlockNumDesc"] = "blockNum_DESC";
    UniqueEventOrderByInput["FromAsc"] = "from_ASC";
    UniqueEventOrderByInput["FromDesc"] = "from_DESC";
    UniqueEventOrderByInput["IdAsc"] = "id_ASC";
    UniqueEventOrderByInput["IdDesc"] = "id_DESC";
    UniqueEventOrderByInput["PriceAsc"] = "price_ASC";
    UniqueEventOrderByInput["PriceDesc"] = "price_DESC";
    UniqueEventOrderByInput["TimestampAsc"] = "timestamp_ASC";
    UniqueEventOrderByInput["TimestampDesc"] = "timestamp_DESC";
    UniqueEventOrderByInput["ToAsc"] = "to_ASC";
    UniqueEventOrderByInput["ToDesc"] = "to_DESC";
    UniqueEventOrderByInput["TypeAsc"] = "type_ASC";
    UniqueEventOrderByInput["TypeDesc"] = "type_DESC";
    UniqueEventOrderByInput["UniqueClassAdminAsc"] = "uniqueClass_admin_ASC";
    UniqueEventOrderByInput["UniqueClassAdminDesc"] = "uniqueClass_admin_DESC";
    UniqueEventOrderByInput["UniqueClassCreatedAtAsc"] = "uniqueClass_createdAt_ASC";
    UniqueEventOrderByInput["UniqueClassCreatedAtDesc"] = "uniqueClass_createdAt_DESC";
    UniqueEventOrderByInput["UniqueClassCreatorAsc"] = "uniqueClass_creator_ASC";
    UniqueEventOrderByInput["UniqueClassCreatorDesc"] = "uniqueClass_creator_DESC";
    UniqueEventOrderByInput["UniqueClassFreezerAsc"] = "uniqueClass_freezer_ASC";
    UniqueEventOrderByInput["UniqueClassFreezerDesc"] = "uniqueClass_freezer_DESC";
    UniqueEventOrderByInput["UniqueClassIdAsc"] = "uniqueClass_id_ASC";
    UniqueEventOrderByInput["UniqueClassIdDesc"] = "uniqueClass_id_DESC";
    UniqueEventOrderByInput["UniqueClassIssuerAsc"] = "uniqueClass_issuer_ASC";
    UniqueEventOrderByInput["UniqueClassIssuerDesc"] = "uniqueClass_issuer_DESC";
    UniqueEventOrderByInput["UniqueClassMaxSupplyAsc"] = "uniqueClass_maxSupply_ASC";
    UniqueEventOrderByInput["UniqueClassMaxSupplyDesc"] = "uniqueClass_maxSupply_DESC";
    UniqueEventOrderByInput["UniqueClassMetadataAsc"] = "uniqueClass_metadata_ASC";
    UniqueEventOrderByInput["UniqueClassMetadataDesc"] = "uniqueClass_metadata_DESC";
    UniqueEventOrderByInput["UniqueClassOwnerAsc"] = "uniqueClass_owner_ASC";
    UniqueEventOrderByInput["UniqueClassOwnerDesc"] = "uniqueClass_owner_DESC";
    UniqueEventOrderByInput["UniqueClassStatusAsc"] = "uniqueClass_status_ASC";
    UniqueEventOrderByInput["UniqueClassStatusDesc"] = "uniqueClass_status_DESC";
    UniqueEventOrderByInput["UniqueInstanceIdAsc"] = "uniqueInstance_id_ASC";
    UniqueEventOrderByInput["UniqueInstanceIdDesc"] = "uniqueInstance_id_DESC";
    UniqueEventOrderByInput["UniqueInstanceInnerIdAsc"] = "uniqueInstance_innerID_ASC";
    UniqueEventOrderByInput["UniqueInstanceInnerIdDesc"] = "uniqueInstance_innerID_DESC";
    UniqueEventOrderByInput["UniqueInstanceMetadataAsc"] = "uniqueInstance_metadata_ASC";
    UniqueEventOrderByInput["UniqueInstanceMetadataDesc"] = "uniqueInstance_metadata_DESC";
    UniqueEventOrderByInput["UniqueInstanceMintedAtAsc"] = "uniqueInstance_mintedAt_ASC";
    UniqueEventOrderByInput["UniqueInstanceMintedAtDesc"] = "uniqueInstance_mintedAt_DESC";
    UniqueEventOrderByInput["UniqueInstancePriceAsc"] = "uniqueInstance_price_ASC";
    UniqueEventOrderByInput["UniqueInstancePriceDesc"] = "uniqueInstance_price_DESC";
    UniqueEventOrderByInput["UniqueInstanceStatusAsc"] = "uniqueInstance_status_ASC";
    UniqueEventOrderByInput["UniqueInstanceStatusDesc"] = "uniqueInstance_status_DESC";
})(UniqueEventOrderByInput = UniqueEventOrderByInput || (UniqueEventOrderByInput = {}));
export var UniqueInstanceOrderByInput;
(function (UniqueInstanceOrderByInput) {
    UniqueInstanceOrderByInput["IdAsc"] = "id_ASC";
    UniqueInstanceOrderByInput["IdDesc"] = "id_DESC";
    UniqueInstanceOrderByInput["InnerIdAsc"] = "innerID_ASC";
    UniqueInstanceOrderByInput["InnerIdDesc"] = "innerID_DESC";
    UniqueInstanceOrderByInput["MetadataAsc"] = "metadata_ASC";
    UniqueInstanceOrderByInput["MetadataDesc"] = "metadata_DESC";
    UniqueInstanceOrderByInput["MintedAtAsc"] = "mintedAt_ASC";
    UniqueInstanceOrderByInput["MintedAtDesc"] = "mintedAt_DESC";
    UniqueInstanceOrderByInput["OwnerIdAsc"] = "owner_id_ASC";
    UniqueInstanceOrderByInput["OwnerIdDesc"] = "owner_id_DESC";
    UniqueInstanceOrderByInput["PriceAsc"] = "price_ASC";
    UniqueInstanceOrderByInput["PriceDesc"] = "price_DESC";
    UniqueInstanceOrderByInput["StatusAsc"] = "status_ASC";
    UniqueInstanceOrderByInput["StatusDesc"] = "status_DESC";
    UniqueInstanceOrderByInput["UniqueClassAdminAsc"] = "uniqueClass_admin_ASC";
    UniqueInstanceOrderByInput["UniqueClassAdminDesc"] = "uniqueClass_admin_DESC";
    UniqueInstanceOrderByInput["UniqueClassCreatedAtAsc"] = "uniqueClass_createdAt_ASC";
    UniqueInstanceOrderByInput["UniqueClassCreatedAtDesc"] = "uniqueClass_createdAt_DESC";
    UniqueInstanceOrderByInput["UniqueClassCreatorAsc"] = "uniqueClass_creator_ASC";
    UniqueInstanceOrderByInput["UniqueClassCreatorDesc"] = "uniqueClass_creator_DESC";
    UniqueInstanceOrderByInput["UniqueClassFreezerAsc"] = "uniqueClass_freezer_ASC";
    UniqueInstanceOrderByInput["UniqueClassFreezerDesc"] = "uniqueClass_freezer_DESC";
    UniqueInstanceOrderByInput["UniqueClassIdAsc"] = "uniqueClass_id_ASC";
    UniqueInstanceOrderByInput["UniqueClassIdDesc"] = "uniqueClass_id_DESC";
    UniqueInstanceOrderByInput["UniqueClassIssuerAsc"] = "uniqueClass_issuer_ASC";
    UniqueInstanceOrderByInput["UniqueClassIssuerDesc"] = "uniqueClass_issuer_DESC";
    UniqueInstanceOrderByInput["UniqueClassMaxSupplyAsc"] = "uniqueClass_maxSupply_ASC";
    UniqueInstanceOrderByInput["UniqueClassMaxSupplyDesc"] = "uniqueClass_maxSupply_DESC";
    UniqueInstanceOrderByInput["UniqueClassMetadataAsc"] = "uniqueClass_metadata_ASC";
    UniqueInstanceOrderByInput["UniqueClassMetadataDesc"] = "uniqueClass_metadata_DESC";
    UniqueInstanceOrderByInput["UniqueClassOwnerAsc"] = "uniqueClass_owner_ASC";
    UniqueInstanceOrderByInput["UniqueClassOwnerDesc"] = "uniqueClass_owner_DESC";
    UniqueInstanceOrderByInput["UniqueClassStatusAsc"] = "uniqueClass_status_ASC";
    UniqueInstanceOrderByInput["UniqueClassStatusDesc"] = "uniqueClass_status_DESC";
})(UniqueInstanceOrderByInput = UniqueInstanceOrderByInput || (UniqueInstanceOrderByInput = {}));
export const NftsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'nfts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'addresses' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uniqueInstancesConnection' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'orderBy' },
                                value: { kind: 'EnumValue', value: 'id_ASC' },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'after' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'first' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'owner' },
                                            value: {
                                                kind: 'ObjectValue',
                                                fields: [
                                                    {
                                                        kind: 'ObjectField',
                                                        name: { kind: 'Name', value: 'id_in' },
                                                        value: { kind: 'Variable', name: { kind: 'Name', value: 'addresses' } },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'edges' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'node' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'innerID' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'uniqueClass' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'metadata' } },
                                                                    { kind: 'Field', name: { kind: 'Name', value: 'maxSupply' } },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pageInfo' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
//# sourceMappingURL=graphql.js.map